import Pesquisa from "../screens/Pesquisa.vue";
import Home from "../screens/Home";
import Historico from "../screens/HistoricoNCM";
import Monitoradas from "../screens/Monitoradas";
import FiltroMonitoramento from "../screens/FiltroMonitoramento";
import Resultados from '../screens/Resultados';

export const routes = [
  {
    path: `/monitoramentoncm`,
    component: Home,
    name: "Home",
    menu: false
  },
  {
    path: `/monitoramentoncm/pesquisa`,
    component: Pesquisa,
    name: "Pesquisa",
    menu: true
  },
  {
    path: `/monitoramentoncm/resultados/:descricao`,
    component: Resultados,
    name: "Resultados",
    menu: false,
  
  },
  {
    path: `/monitoramentoncm/minhasncms`,
    component: Monitoradas,
    name: "Minhas NCMs",
    menu: true
  },
  {
    path: `/monitoramentoncm/historico/:ncm`,
    component: Historico,
    name: "Histórico",
    menu: false
  },
  {
    path: `/monitoramentoncm/filtromonitoramento/:ncm`,
    component: FiltroMonitoramento,
    name: "Filtros",
    menu: false
  },
  { path: "*", component: Pesquisa, menu: false }
];
